// --- Our Modules --------------------------------------------------------------------------------
import type { TyIconName } from "./types";
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
type Props = { name: TyIconName; size?: number };

/**
 * The icons are the Figma file's own SVGs, untouched, in `public/icons`. They are painted as a CSS
 * mask rather than an `<img>` so one file serves every state — an active tab is gold and an idle one
 * is navy without shipping two copies of the same art.
 */
export default function Icon({ name, size = 24 }: Props) {
    return (
        <span
            className="icon"
            style={{ width: size, height: size, maskImage: `url(/icons/${name}.svg)`, WebkitMaskImage: `url(/icons/${name}.svg)` }}
        />
    );
}
